import script from "./HomePageValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePageValue.vue?vue&type=script&setup=true&lang=ts"

import "./HomePageValue.vue?vue&type=style&index=0&id=3de4ef96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de4ef96"]])

export default __exports__